module.exports = __webpack_public_path__ + "media/img/pages/companies/supsi-a4f42056e5c5c912b61bde37d2f55ff4.png";